var _createForOfIteratorHelper = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/createForOfIteratorHelper.js").default;

var _regeneratorRuntime = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/asyncToGenerator.js").default;

var _objectSpread = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/objectSpread2.js").default;

var _defineProperty2 = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/defineProperty.js").default;

var _slicedToArray = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/slicedToArray.js").default;

var _toConsumableArray = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/toConsumableArray.js").default;

!function webpackUniversalModuleDefinition(e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports["@wordpress/data"] = t() : (e.wp = e.wp || {}, e.wp.data = t());
}(self, function () {
  return function () {
    var e = {
      221: function _(e) {
        function _extends() {
          return e.exports = _extends = Object.assign || function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var r = arguments[t];

              for (var n in r) {
                Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
              }
            }

            return e;
          }, e.exports.__esModule = !0, e.exports.default = e.exports, _extends.apply(this, arguments);
        }

        e.exports = _extends, e.exports.__esModule = !0, e.exports.default = e.exports;
      },
      424: function _(e) {
        e.exports = function _interopRequireDefault(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }, e.exports.__esModule = !0, e.exports.default = e.exports;
      },
      2: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = t.Context = t.AsyncModeConsumer = void 0;
        var n = (0, r(753).createContext)(!1);
        t.Context = n;
        var o = n.Consumer,
            i = n.Provider,
            s = o;
        t.AsyncModeConsumer = s;
        var u = i;
        t.default = u;
      },
      67: function _(e, t, r) {
        "use strict";

        var n = r(424);
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), Object.defineProperty(t, "AsyncModeConsumer", {
          enumerable: !0,
          get: function get() {
            return i.AsyncModeConsumer;
          }
        }), Object.defineProperty(t, "AsyncModeProvider", {
          enumerable: !0,
          get: function get() {
            return i.default;
          }
        }), Object.defineProperty(t, "useAsyncMode", {
          enumerable: !0,
          get: function get() {
            return o.default;
          }
        });

        var o = n(r(620)),
            i = function _interopRequireWildcard(e, t) {
          if (!t && e && e.__esModule) return e;
          if (null === e || "object" != typeof e && "function" != typeof e) return {
            default: e
          };

          var r = _getRequireWildcardCache(t);

          if (r && r.has(e)) return r.get(e);
          var n = {},
              o = Object.defineProperty && Object.getOwnPropertyDescriptor;

          for (var i in e) {
            if ("default" !== i && Object.prototype.hasOwnProperty.call(e, i)) {
              var s = o ? Object.getOwnPropertyDescriptor(e, i) : null;
              s && (s.get || s.set) ? Object.defineProperty(n, i, s) : n[i] = e[i];
            }
          }

          n.default = e, r && r.set(e, n);
          return n;
        }(r(2));

        function _getRequireWildcardCache(e) {
          if ("function" != typeof WeakMap) return null;
          var t = new WeakMap(),
              r = new WeakMap();
          return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
            return e ? r : t;
          })(e);
        }
      },
      620: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = function useAsyncMode() {
          return (0, n.useContext)(o.Context);
        };
        var n = r(753),
            o = r(2);
      },
      805: function _(e, t, r) {
        "use strict";

        var n = r(424);
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = t.RegistryConsumer = t.Context = void 0;
        var o = r(753),
            i = n(r(57));
        var s = (0, o.createContext)(i.default);
        t.Context = s;
        var u = s.Consumer,
            a = s.Provider,
            c = u;
        t.RegistryConsumer = c;
        var l = a;
        t.default = l;
      },
      500: function _(e, t, r) {
        "use strict";

        var n = r(424);
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), Object.defineProperty(t, "RegistryConsumer", {
          enumerable: !0,
          get: function get() {
            return o.RegistryConsumer;
          }
        }), Object.defineProperty(t, "RegistryProvider", {
          enumerable: !0,
          get: function get() {
            return o.default;
          }
        }), Object.defineProperty(t, "useRegistry", {
          enumerable: !0,
          get: function get() {
            return i.default;
          }
        });

        var o = function _interopRequireWildcard(e, t) {
          if (!t && e && e.__esModule) return e;
          if (null === e || "object" != typeof e && "function" != typeof e) return {
            default: e
          };

          var r = _getRequireWildcardCache(t);

          if (r && r.has(e)) return r.get(e);
          var n = {},
              o = Object.defineProperty && Object.getOwnPropertyDescriptor;

          for (var i in e) {
            if ("default" !== i && Object.prototype.hasOwnProperty.call(e, i)) {
              var s = o ? Object.getOwnPropertyDescriptor(e, i) : null;
              s && (s.get || s.set) ? Object.defineProperty(n, i, s) : n[i] = e[i];
            }
          }

          n.default = e, r && r.set(e, n);
          return n;
        }(r(805)),
            i = n(r(898));

        function _getRequireWildcardCache(e) {
          if ("function" != typeof WeakMap) return null;
          var t = new WeakMap(),
              r = new WeakMap();
          return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
            return e ? r : t;
          })(e);
        }
      },
      898: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = function useRegistry() {
          return (0, n.useContext)(o.Context);
        };
        var n = r(753),
            o = r(805);
      },
      123: function _(e, t, r) {
        "use strict";

        var n = r(424);
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), Object.defineProperty(t, "useDispatch", {
          enumerable: !0,
          get: function get() {
            return o.default;
          }
        }), Object.defineProperty(t, "useDispatchWithMap", {
          enumerable: !0,
          get: function get() {
            return i.default;
          }
        });
        var o = n(r(103)),
            i = n(r(227));
      },
      227: function _(e, t, r) {
        "use strict";

        var n = r(424);
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = void 0;
        var o = r(793),
            i = r(753),
            s = r(200),
            u = n(r(898));

        var _default = function _default(e, t) {
          var r = (0, u.default)(),
              n = (0, i.useRef)(e);
          return (0, s.useIsomorphicLayoutEffect)(function () {
            n.current = e;
          }), (0, i.useMemo)(function () {
            var e = n.current(r.dispatch, r);
            return (0, o.mapValues)(e, function (e, t) {
              return "function" != typeof e && console.warn("Property ".concat(t, " returned from dispatchMap in useDispatchWithMap must be a function.")), function () {
                var _n$current;

                return (_n$current = n.current(r.dispatch, r))[t].apply(_n$current, arguments);
              };
            });
          }, [r].concat(_toConsumableArray(t)));
        };

        t.default = _default;
      },
      103: function _(e, t, r) {
        "use strict";

        var n = r(424);
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = void 0;
        var o = n(r(898));

        var _default = function _default(e) {
          var _ref = (0, o.default)(),
              t = _ref.dispatch;

          return void 0 === e ? t : t(e);
        };

        t.default = _default;
      },
      230: function _(e, t, r) {
        "use strict";

        var n = r(424);
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = function useSelect(e, t) {
          var r = "function" != typeof e;
          r && (t = []);

          var n = (0, s.useCallback)(e, t),
              i = (0, c.default)(),
              d = (0, l.default)(),
              p = (0, o.useMemoOne)(function () {
            return {
              queue: !0
            };
          }, [i]),
              _ref2 = (0, s.useReducer)(function (e) {
            return e + 1;
          }, 0),
              _ref3 = _slicedToArray(_ref2, 2),
              g = _ref3[1],
              v = (0, s.useRef)(),
              y = (0, s.useRef)(d),
              b = (0, s.useRef)(),
              _ = (0, s.useRef)(),
              h = (0, s.useRef)(),
              O = (0, s.useRef)([]),
              m = (0, s.useCallback)(function (e) {
            return i.__experimentalMarkListeningStores(e, O);
          }, [i]),
              S = (0, s.useMemo)(function () {
            return {};
          }, t || []);

          var R;
          if (!r) try {
            R = v.current !== n || _.current ? m(function () {
              return n(i.select, i);
            }) : b.current;
          } catch (e) {
            var _t = "An error occurred while running 'mapSelect': ".concat(e.message);

            _.current && (_t += "\nThe error may be correlated with this previous error:\n", _t += "".concat(_.current.stack, "\n\n"), _t += "Original stack trace:"), console.error(_t), R = b.current;
          }
          return (0, a.useIsomorphicLayoutEffect)(function () {
            r || (v.current = n, b.current = R, _.current = void 0, h.current = !0, y.current !== d && (y.current = d, f.flush(p)));
          }), (0, a.useIsomorphicLayoutEffect)(function () {
            if (r) return;

            var onStoreChange = function onStoreChange() {
              if (h.current) {
                try {
                  var _e = m(function () {
                    return v.current(i.select, i);
                  });

                  if ((0, u.default)(b.current, _e)) return;
                  b.current = _e;
                } catch (e) {
                  _.current = e;
                }

                g();
              }
            };

            y.current ? f.add(p, onStoreChange) : onStoreChange();

            var onChange = function onChange() {
              y.current ? f.add(p, onStoreChange) : onStoreChange();
            },
                e = O.current.map(function (e) {
              return i.__experimentalSubscribeStore(e, onChange);
            });

            return function () {
              h.current = !1, e.forEach(function (e) {
                return null == e ? void 0 : e();
              }), f.flush(p);
            };
          }, [i, m, S, r]), r ? i.select(e) : R;
        };
        var o = r(625),
            i = r(800),
            s = r(753),
            u = n(r(104)),
            a = r(200),
            c = n(r(898)),
            l = n(r(620));
        var f = (0, i.createQueue)();
      },
      683: function _(e, t, r) {
        "use strict";

        var n = r(424);
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = void 0;
        var o = r(753),
            i = n(r(221)),
            s = r(200),
            u = r(123);

        var _default = function _default(e) {
          return (0, s.createHigherOrderComponent)(function (t) {
            return function (r) {
              var n = (0, u.useDispatchWithMap)(function (t, n) {
                return e(t, r, n);
              }, []);
              return (0, o.createElement)(t, (0, i.default)({}, r, n));
            };
          }, "withDispatch");
        };

        t.default = _default;
      },
      216: function _(e, t, r) {
        "use strict";

        var n = r(424);
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = void 0;
        var o = r(753),
            i = n(r(221)),
            s = r(200),
            u = r(500);
        var a = (0, s.createHigherOrderComponent)(function (e) {
          return function (t) {
            return (0, o.createElement)(u.RegistryConsumer, null, function (r) {
              return (0, o.createElement)(e, (0, i.default)({}, t, {
                registry: r
              }));
            });
          };
        }, "withRegistry");
        t.default = a;
      },
      804: function _(e, t, r) {
        "use strict";

        var n = r(424);
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = void 0;
        var o = r(753),
            i = n(r(221)),
            s = r(200),
            u = n(r(230));

        var _default = function _default(e) {
          return (0, s.createHigherOrderComponent)(function (t) {
            return (0, s.pure)(function (r) {
              var n = (0, u.default)(function (t, n) {
                return e(t, r, n);
              });
              return (0, o.createElement)(t, (0, i.default)({}, r, n));
            });
          }, "withSelect");
        };

        t.default = _default;
      },
      668: function _(e, t, r) {
        "use strict";

        var _c;

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.controls = t.builtinControls = void 0;
        var n = r(793),
            o = r(546);
        var i = "@@data/SELECT",
            s = "@@data/RESOLVE_SELECT",
            u = "@@data/DISPATCH";
        var a = {
          select: function select(e, t) {
            for (var r = arguments.length, o = new Array(r > 2 ? r - 2 : 0), s = 2; s < r; s++) {
              o[s - 2] = arguments[s];
            }

            return {
              type: i,
              storeKey: (0, n.isObject)(e) ? e.name : e,
              selectorName: t,
              args: o
            };
          },
          resolveSelect: function resolveSelect(e, t) {
            for (var r = arguments.length, o = new Array(r > 2 ? r - 2 : 0), i = 2; i < r; i++) {
              o[i - 2] = arguments[i];
            }

            return {
              type: s,
              storeKey: (0, n.isObject)(e) ? e.name : e,
              selectorName: t,
              args: o
            };
          },
          dispatch: function dispatch(e, t) {
            for (var r = arguments.length, o = new Array(r > 2 ? r - 2 : 0), i = 2; i < r; i++) {
              o[i - 2] = arguments[i];
            }

            return {
              type: u,
              storeKey: (0, n.isObject)(e) ? e.name : e,
              actionName: t,
              args: o
            };
          }
        };
        t.controls = a;
        var c = (_c = {}, _defineProperty2(_c, i, (0, o.createRegistryControl)(function (e) {
          return function (t) {
            var _e$select;

            var r = t.storeKey,
                n = t.selectorName,
                o = t.args;
            return (_e$select = e.select(r))[n].apply(_e$select, _toConsumableArray(o));
          };
        })), _defineProperty2(_c, s, (0, o.createRegistryControl)(function (e) {
          return function (t) {
            var _e$i;

            var r = t.storeKey,
                n = t.selectorName,
                o = t.args;
            var i = e.select(r)[n].hasResolver ? "resolveSelect" : "select";
            return (_e$i = e[i](r))[n].apply(_e$i, _toConsumableArray(o));
          };
        })), _defineProperty2(_c, u, (0, o.createRegistryControl)(function (e) {
          return function (t) {
            var _e$dispatch;

            var r = t.storeKey,
                n = t.actionName,
                o = t.args;
            return (_e$dispatch = e.dispatch(r))[n].apply(_e$dispatch, _toConsumableArray(o));
          };
        })), _c);
        t.builtinControls = c;
      },
      57: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = void 0;
        var n = (0, r(838).createRegistry)();
        t.default = n;
      },
      546: function _(e, t) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.createRegistryControl = function createRegistryControl(e) {
          return e.isRegistryControl = !0, e;
        }, t.createRegistrySelector = function createRegistrySelector(e) {
          var selector = function selector() {
            return e(selector.registry.select).apply(void 0, arguments);
          };

          return selector.isRegistrySelector = !0, selector;
        };
      },
      453: function _(e, t, r) {
        "use strict";

        var n = r(424);
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), Object.defineProperty(t, "AsyncModeProvider", {
          enumerable: !0,
          get: function get() {
            return p.AsyncModeProvider;
          }
        }), Object.defineProperty(t, "RegistryConsumer", {
          enumerable: !0,
          get: function get() {
            return l.RegistryConsumer;
          }
        }), Object.defineProperty(t, "RegistryProvider", {
          enumerable: !0,
          get: function get() {
            return l.RegistryProvider;
          }
        }), Object.defineProperty(t, "combineReducers", {
          enumerable: !0,
          get: function get() {
            return o.default;
          }
        }), Object.defineProperty(t, "controls", {
          enumerable: !0,
          get: function get() {
            return y.controls;
          }
        }), Object.defineProperty(t, "createReduxStore", {
          enumerable: !0,
          get: function get() {
            return b.default;
          }
        }), Object.defineProperty(t, "createRegistry", {
          enumerable: !0,
          get: function get() {
            return g.createRegistry;
          }
        }), Object.defineProperty(t, "createRegistryControl", {
          enumerable: !0,
          get: function get() {
            return v.createRegistryControl;
          }
        }), Object.defineProperty(t, "createRegistrySelector", {
          enumerable: !0,
          get: function get() {
            return v.createRegistrySelector;
          }
        }), t.use = t.subscribe = t.select = t.resolveSelect = t.registerStore = t.registerGenericStore = t.register = t.plugins = t.dispatch = void 0, Object.defineProperty(t, "useDispatch", {
          enumerable: !0,
          get: function get() {
            return d.useDispatch;
          }
        }), Object.defineProperty(t, "useRegistry", {
          enumerable: !0,
          get: function get() {
            return l.useRegistry;
          }
        }), Object.defineProperty(t, "useSelect", {
          enumerable: !0,
          get: function get() {
            return f.default;
          }
        }), Object.defineProperty(t, "withDispatch", {
          enumerable: !0,
          get: function get() {
            return a.default;
          }
        }), Object.defineProperty(t, "withRegistry", {
          enumerable: !0,
          get: function get() {
            return c.default;
          }
        }), Object.defineProperty(t, "withSelect", {
          enumerable: !0,
          get: function get() {
            return u.default;
          }
        });

        var o = n(r(196)),
            i = n(r(57)),
            s = function _interopRequireWildcard(e, t) {
          if (!t && e && e.__esModule) return e;
          if (null === e || "object" != typeof e && "function" != typeof e) return {
            default: e
          };

          var r = _getRequireWildcardCache(t);

          if (r && r.has(e)) return r.get(e);
          var n = {},
              o = Object.defineProperty && Object.getOwnPropertyDescriptor;

          for (var i in e) {
            if ("default" !== i && Object.prototype.hasOwnProperty.call(e, i)) {
              var s = o ? Object.getOwnPropertyDescriptor(e, i) : null;
              s && (s.get || s.set) ? Object.defineProperty(n, i, s) : n[i] = e[i];
            }
          }

          n.default = e, r && r.set(e, n);
          return n;
        }(r(724));

        t.plugins = s;
        var u = n(r(804)),
            a = n(r(683)),
            c = n(r(216)),
            l = r(500),
            f = n(r(230)),
            d = r(123),
            p = r(67),
            g = r(838),
            v = r(546),
            y = r(668),
            b = n(r(721));

        function _getRequireWildcardCache(e) {
          if ("function" != typeof WeakMap) return null;
          var t = new WeakMap(),
              r = new WeakMap();
          return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
            return e ? r : t;
          })(e);
        }

        var _ = i.default.select;
        t.select = _;
        var h = i.default.resolveSelect;
        t.resolveSelect = h;
        var O = i.default.dispatch;
        t.dispatch = O;
        var m = i.default.subscribe;
        t.subscribe = m;
        var S = i.default.registerGenericStore;
        t.registerGenericStore = S;
        var R = i.default.registerStore;
        t.registerStore = R;
        var P = i.default.use;
        t.use = P;
        var w = i.default.register;
        t.register = w;
      },
      525: function _(e, t, r) {
        "use strict";

        var n = r(424);
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = void 0;
        var o = n(r(703));

        t.default = function (e) {
          return (0, o.default)("wp.data.plugins.controls", {
            since: "5.4",
            hint: "The controls plugins is now baked-in."
          }), e;
        };
      },
      724: function _(e, t, r) {
        "use strict";

        var n = r(424);
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), Object.defineProperty(t, "controls", {
          enumerable: !0,
          get: function get() {
            return o.default;
          }
        }), Object.defineProperty(t, "persistence", {
          enumerable: !0,
          get: function get() {
            return i.default;
          }
        });
        var o = n(r(525)),
            i = n(r(989));
      },
      989: function _(e, t, r) {
        "use strict";

        var n = r(424);
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.createPersistenceInterface = createPersistenceInterface, t.default = void 0, t.migrateFeaturePreferencesToInterfaceStore = migrateFeaturePreferencesToInterfaceStore, t.withLazySameState = void 0;
        var o = r(793),
            i = n(r(114)),
            s = r(453);

        var u = i.default,
            a = "WP_DATA",
            withLazySameState = function withLazySameState(e) {
          return function (t, r) {
            return r.nextState === t ? t : e(t, r);
          };
        };

        function createPersistenceInterface(e) {
          var _e$storage = e.storage,
              t = _e$storage === void 0 ? u : _e$storage,
              _e$storageKey = e.storageKey,
              r = _e$storageKey === void 0 ? a : _e$storageKey;
          var n;
          return {
            get: function getData() {
              if (void 0 === n) {
                var _e2 = t.getItem(r);

                if (null === _e2) n = {};else try {
                  n = JSON.parse(_e2);
                } catch (e) {
                  n = {};
                }
              }

              return n;
            },
            set: function setData(e, o) {
              n = _objectSpread(_objectSpread({}, n), {}, _defineProperty2({}, e, o)), t.setItem(r, JSON.stringify(n));
            }
          };
        }

        function persistencePlugin(e, t) {
          var r = createPersistenceInterface(t);
          return {
            registerStore: function registerStore(t, n) {
              if (!n.persist) return e.registerStore(t, n);
              var i = r.get()[t];

              if (void 0 !== i) {
                var _e3 = n.reducer(n.initialState, {
                  type: "@@WP/PERSISTENCE_RESTORE"
                });

                _e3 = (0, o.isPlainObject)(_e3) && (0, o.isPlainObject)(i) ? (0, o.merge)({}, _e3, i) : i, n = _objectSpread(_objectSpread({}, n), {}, {
                  initialState: _e3
                });
              }

              var u = e.registerStore(t, n);
              return u.subscribe(function createPersistOnChange(e, t, n) {
                var o;

                if (Array.isArray(n)) {
                  var _e4 = n.reduce(function (e, t) {
                    return Object.assign(e, _defineProperty2({}, t, function (e, r) {
                      return r.nextState[t];
                    }));
                  }, {});

                  o = withLazySameState((0, s.combineReducers)(_e4));
                } else o = function o(e, t) {
                  return t.nextState;
                };

                var i = o(void 0, {
                  nextState: e()
                });
                return function () {
                  var n = o(i, {
                    nextState: e()
                  });
                  n !== i && (r.set(t, n), i = n);
                };
              }(u.getState, t, n.persist)), u;
            }
          };
        }

        function migrateFeaturePreferencesToInterfaceStore(e, t) {
          var r;
          var n = "core/interface",
              o = e.get(),
              i = null === (r = o[t]) || void 0 === r ? void 0 : r.preferences,
              s = null == i ? void 0 : i.features;

          if (s) {
            var u, a;

            var _r = null === (u = o["core/interface"]) || void 0 === u || null === (a = u.preferences) || void 0 === a ? void 0 : a.features;

            null != _r && _r[t] || (e.set(n, {
              preferences: {
                features: _objectSpread(_objectSpread({}, _r), {}, _defineProperty2({}, t, s))
              }
            }), e.set(t, {
              preferences: _objectSpread(_objectSpread({}, i), {}, {
                features: void 0
              })
            }));
          }
        }

        t.withLazySameState = withLazySameState, persistencePlugin.__unstableMigrate = function (e) {
          var t = createPersistenceInterface(e);
          migrateFeaturePreferencesToInterfaceStore(t, "core/edit-widgets"), migrateFeaturePreferencesToInterfaceStore(t, "core/customize-widgets"), migrateFeaturePreferencesToInterfaceStore(t, "core/edit-post");
        };
        var c = persistencePlugin;
        t.default = c;
      },
      114: function _(e, t, r) {
        "use strict";

        var n = r(424);
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = void 0;
        var o = n(r(645));
        var i;

        try {
          i = window.localStorage, i.setItem("__wpDataTestLocalStorage", ""), i.removeItem("__wpDataTestLocalStorage");
        } catch (e) {
          i = o.default;
        }

        var s = i;
        t.default = s;
      },
      645: function _(e, t) {
        "use strict";

        var r;
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = void 0;
        var n = {
          getItem: function getItem(e) {
            return r && r[e] ? r[e] : null;
          },
          setItem: function setItem(e, t) {
            r || n.clear(), r[e] = String(t);
          },
          clear: function clear() {
            r = Object.create(null);
          }
        };
        var o = n;
        t.default = o;
      },
      187: function _(e, t, r) {
        "use strict";

        var n = r(424);
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = void 0;
        var o = n(r(626));

        var _default = function _default() {
          return function (e) {
            return function (t) {
              return (0, o.default)(t) ? t.then(function (t) {
                if (t) return e(t);
              }) : e(t);
            };
          };
        };

        t.default = _default;
      },
      721: function _(e, t, r) {
        "use strict";

        var n = r(424);
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = function createReduxStore(e, t) {
          return {
            name: e,
            instantiate: function instantiate(r) {
              var n = t.reducer,
                  y = function instantiateReduxStore(e, t, r, n) {
                var u = _objectSpread(_objectSpread({}, t.controls), c.builtinControls),
                    g = (0, i.mapValues)(u, function (e) {
                  return e.isRegistryControl ? e(r) : e;
                }),
                    v = [(0, f.default)(r, e), l.default, (0, a.default)(g)];

                t.__experimentalUseThunks && v.push((0, d.default)(n));
                var y = [(0, o.applyMiddleware).apply(void 0, v)];
                "undefined" != typeof window && window.__REDUX_DEVTOOLS_EXTENSION__ && y.push(window.__REDUX_DEVTOOLS_EXTENSION__({
                  name: e,
                  instanceId: e
                }));
                var b = t.reducer,
                    _ = t.initialState,
                    h = (0, s.default)({
                  metadata: p.default,
                  root: b
                });
                return (0, o.createStore)(h, {
                  root: _
                }, (0, i.flowRight)(y));
              }(e, t, r, {
                registry: r,

                get dispatch() {
                  return Object.assign(function (e) {
                    return y.dispatch(e);
                  }, getActions());
                },

                get select() {
                  return Object.assign(function (e) {
                    return e(y.__unstableOriginalGetState());
                  }, getSelectors());
                },

                get resolveSelect() {
                  return getResolveSelectors();
                }

              }),
                  b = function createResolversCache() {
                var e = {};
                return {
                  isRunning: function isRunning(t, r) {
                    return e[t] && e[t].get(trimUndefinedValues(r));
                  },
                  clear: function clear(t, r) {
                    e[t] && e[t].delete(trimUndefinedValues(r));
                  },
                  markAsRunning: function markAsRunning(t, r) {
                    e[t] || (e[t] = new u.default()), e[t].set(trimUndefinedValues(r), !0);
                  }
                };
              }();

              var _;

              var h = function mapActions(e, t) {
                var createBoundAction = function createBoundAction(e) {
                  return function () {
                    return Promise.resolve(t.dispatch(e.apply(void 0, arguments)));
                  };
                };

                return (0, i.mapValues)(e, createBoundAction);
              }(_objectSpread(_objectSpread({}, v), t.actions), y);

              var O = function mapSelectors(e, t) {
                var createStateSelector = function createStateSelector(e) {
                  var r = function runSelector() {
                    var r = arguments.length,
                        n = new Array(r + 1);
                    n[0] = t.__unstableOriginalGetState();

                    for (var _e5 = 0; _e5 < r; _e5++) {
                      n[_e5 + 1] = arguments[_e5];
                    }

                    return e.apply(void 0, n);
                  };

                  return r.hasResolver = !1, r;
                };

                return (0, i.mapValues)(e, createStateSelector);
              }(_objectSpread(_objectSpread({}, (0, i.mapValues)(g, function (e) {
                return function (t) {
                  for (var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++) {
                    n[o - 1] = arguments[o];
                  }

                  return e.apply(void 0, [t.metadata].concat(n));
                };
              })), (0, i.mapValues)(t.selectors, function (e) {
                return e.isRegistrySelector && (e.registry = r), function (t) {
                  for (var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++) {
                    n[o - 1] = arguments[o];
                  }

                  return e.apply(void 0, [t.root].concat(n));
                };
              })), y);

              if (t.resolvers) {
                var _e6 = function mapResolvers(e, t, r, n) {
                  var o = (0, i.mapValues)(e, function (e) {
                    return e.fulfill ? e : _objectSpread(_objectSpread({}, e), {}, {
                      fulfill: e
                    });
                  }),
                      mapSelector = function mapSelector(t, i) {
                    var s = e[i];
                    if (!s) return t.hasResolver = !1, t;

                    var selectorResolver = function selectorResolver() {
                      for (var e = arguments.length, u = new Array(e), a = 0; a < e; a++) {
                        u[a] = arguments[a];
                      }

                      function fulfillSelector() {
                        return _fulfillSelector.apply(this, arguments);
                      }

                      function _fulfillSelector() {
                        _fulfillSelector = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                          var e, _r$__unstableOriginal, t;

                          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                            while (1) {
                              switch (_context2.prev = _context2.next) {
                                case 0:
                                  e = r.getState();

                                  if (!(n.isRunning(i, u) || "function" == typeof s.isFulfilled && s.isFulfilled.apply(s, [e].concat(u)))) {
                                    _context2.next = 3;
                                    break;
                                  }

                                  return _context2.abrupt("return");

                                case 3:
                                  _r$__unstableOriginal = r.__unstableOriginalGetState(), t = _r$__unstableOriginal.metadata;
                                  g.hasStartedResolution(t, i, u) || (n.markAsRunning(i, u), setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                                      while (1) {
                                        switch (_context.prev = _context.next) {
                                          case 0:
                                            n.clear(i, u);
                                            r.dispatch(v.startResolution(i, u));
                                            _context.next = 4;
                                            return fulfillResolver.apply(void 0, [r, o, i].concat(u));

                                          case 4:
                                            r.dispatch(v.finishResolution(i, u));

                                          case 5:
                                          case "end":
                                            return _context.stop();
                                        }
                                      }
                                    }, _callee);
                                  }))));

                                case 5:
                                case "end":
                                  return _context2.stop();
                              }
                            }
                          }, _callee2);
                        }));
                        return _fulfillSelector.apply(this, arguments);
                      }

                      return fulfillSelector.apply(void 0, u), t.apply(void 0, u);
                    };

                    return selectorResolver.hasResolver = !0, selectorResolver;
                  };

                  return {
                    resolvers: o,
                    selectors: (0, i.mapValues)(t, mapSelector)
                  };
                }(t.resolvers, O, y, b);

                _ = _e6.resolvers, O = _e6.selectors;
              }

              var m = function mapResolveSelectors(e, t) {
                return (0, i.mapValues)((0, i.omit)(e, ["getIsResolving", "hasStartedResolution", "hasFinishedResolution", "isResolving", "getCachedResolvers"]), function (r, n) {
                  return function () {
                    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++) {
                      i[s] = arguments[s];
                    }

                    return new Promise(function (o) {
                      var hasFinished = function hasFinished() {
                        return e.hasFinishedResolution(n, i);
                      },
                          getResult = function getResult() {
                        return r.apply(null, i);
                      },
                          s = getResult();

                      if (hasFinished()) return o(s);
                      var u = t.subscribe(function () {
                        hasFinished() && (u(), o(getResult()));
                      });
                    });
                  };
                });
              }(O, y),
                  getSelectors = function getSelectors() {
                return O;
              },
                  getActions = function getActions() {
                return h;
              },
                  getResolveSelectors = function getResolveSelectors() {
                return m;
              };

              y.__unstableOriginalGetState = y.getState, y.getState = function () {
                return y.__unstableOriginalGetState().root;
              };

              var S = y && function (e) {
                var t = y.__unstableOriginalGetState();

                return y.subscribe(function () {
                  var r = y.__unstableOriginalGetState(),
                      n = r !== t;

                  t = r, n && e();
                });
              };

              return {
                reducer: n,
                store: y,
                actions: h,
                selectors: O,
                resolvers: _,
                getSelectors: getSelectors,
                getResolveSelectors: getResolveSelectors,
                getActions: getActions,
                subscribe: S
              };
            }
          };
        };

        var o = r(671),
            i = r(793),
            s = n(r(196)),
            u = n(r(820)),
            a = n(r(40)),
            c = r(668),
            l = n(r(187)),
            f = n(r(988)),
            d = n(r(602)),
            p = n(r(372)),
            g = _interopRequireWildcard(r(336)),
            v = _interopRequireWildcard(r(183));

        function _getRequireWildcardCache(e) {
          if ("function" != typeof WeakMap) return null;
          var t = new WeakMap(),
              r = new WeakMap();
          return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
            return e ? r : t;
          })(e);
        }

        function _interopRequireWildcard(e, t) {
          if (!t && e && e.__esModule) return e;
          if (null === e || "object" != typeof e && "function" != typeof e) return {
            default: e
          };

          var r = _getRequireWildcardCache(t);

          if (r && r.has(e)) return r.get(e);
          var n = {},
              o = Object.defineProperty && Object.getOwnPropertyDescriptor;

          for (var i in e) {
            if ("default" !== i && Object.prototype.hasOwnProperty.call(e, i)) {
              var s = o ? Object.getOwnPropertyDescriptor(e, i) : null;
              s && (s.get || s.set) ? Object.defineProperty(n, i, s) : n[i] = e[i];
            }
          }

          return n.default = e, r && r.set(e, n), n;
        }

        var trimUndefinedValues = function trimUndefinedValues(e) {
          var t = _toConsumableArray(e);

          for (var _e7 = t.length - 1; _e7 >= 0; _e7--) {
            void 0 === t[_e7] && t.splice(_e7, 1);
          }

          return t;
        };

        function fulfillResolver(_x, _x2, _x3) {
          return _fulfillResolver.apply(this, arguments);
        }

        function _fulfillResolver() {
          _fulfillResolver = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(e, t, r) {
            var n,
                o,
                s,
                u,
                a,
                _args3 = arguments;
            return _regeneratorRuntime.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    n = (0, i.get)(t, [r]);

                    if (n) {
                      _context3.next = 3;
                      break;
                    }

                    return _context3.abrupt("return");

                  case 3:
                    for (o = _args3.length, s = new Array(o > 3 ? o - 3 : 0), u = 3; u < o; u++) {
                      s[u - 3] = _args3[u];
                    }

                    a = n.fulfill.apply(n, s);
                    _context3.t0 = a;

                    if (!_context3.t0) {
                      _context3.next = 9;
                      break;
                    }

                    _context3.next = 9;
                    return e.dispatch(a);

                  case 9:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3);
          }));
          return _fulfillResolver.apply(this, arguments);
        }
      },
      183: function _(e, t) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.finishResolution = function finishResolution(e, t) {
          return {
            type: "FINISH_RESOLUTION",
            selectorName: e,
            args: t
          };
        }, t.finishResolutions = function finishResolutions(e, t) {
          return {
            type: "FINISH_RESOLUTIONS",
            selectorName: e,
            args: t
          };
        }, t.invalidateResolution = function invalidateResolution(e, t) {
          return {
            type: "INVALIDATE_RESOLUTION",
            selectorName: e,
            args: t
          };
        }, t.invalidateResolutionForStore = function invalidateResolutionForStore() {
          return {
            type: "INVALIDATE_RESOLUTION_FOR_STORE"
          };
        }, t.invalidateResolutionForStoreSelector = function invalidateResolutionForStoreSelector(e) {
          return {
            type: "INVALIDATE_RESOLUTION_FOR_STORE_SELECTOR",
            selectorName: e
          };
        }, t.startResolution = function startResolution(e, t) {
          return {
            type: "START_RESOLUTION",
            selectorName: e,
            args: t
          };
        }, t.startResolutions = function startResolutions(e, t) {
          return {
            type: "START_RESOLUTIONS",
            selectorName: e,
            args: t
          };
        };
      },
      372: function _(e, t, r) {
        "use strict";

        var n = r(424);
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = void 0;
        var o = r(793),
            i = n(r(820));
        var s = (0, r(836).onSubKey)("selectorName")(function () {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : new i.default(),
              t = arguments.length > 1 ? arguments[1] : void 0;

          switch (t.type) {
            case "START_RESOLUTION":
            case "FINISH_RESOLUTION":
              {
                var _r2 = "START_RESOLUTION" === t.type,
                    _n = new i.default(e);

                return _n.set(t.args, _r2), _n;
              }

            case "START_RESOLUTIONS":
            case "FINISH_RESOLUTIONS":
              {
                var _r3 = "START_RESOLUTIONS" === t.type,
                    _n2 = new i.default(e);

                var _iterator = _createForOfIteratorHelper(t.args),
                    _step;

                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    var _e8 = _step.value;

                    _n2.set(_e8, _r3);
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }

                return _n2;
              }

            case "INVALIDATE_RESOLUTION":
              {
                var _r4 = new i.default(e);

                return _r4.delete(t.args), _r4;
              }
          }

          return e;
        });

        var _default = function _default() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              t = arguments.length > 1 ? arguments[1] : void 0;

          switch (t.type) {
            case "INVALIDATE_RESOLUTION_FOR_STORE":
              return {};

            case "INVALIDATE_RESOLUTION_FOR_STORE_SELECTOR":
              return (0, o.has)(e, [t.selectorName]) ? (0, o.omit)(e, [t.selectorName]) : e;

            case "START_RESOLUTION":
            case "FINISH_RESOLUTION":
            case "START_RESOLUTIONS":
            case "FINISH_RESOLUTIONS":
            case "INVALIDATE_RESOLUTION":
              return s(e, t);
          }

          return e;
        };

        t.default = _default;
      },
      336: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getCachedResolvers = function getCachedResolvers(e) {
          return e;
        }, t.getIsResolving = getIsResolving, t.hasFinishedResolution = function hasFinishedResolution(e, t) {
          var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [];
          return !1 === getIsResolving(e, t, r);
        }, t.hasStartedResolution = function hasStartedResolution(e, t) {
          var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [];
          return void 0 !== getIsResolving(e, t, r);
        }, t.isResolving = function isResolving(e, t) {
          var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [];
          return !0 === getIsResolving(e, t, r);
        };
        var n = r(793);

        function getIsResolving(e, t, r) {
          var o = (0, n.get)(e, [t]);
          if (o) return o.get(r);
        }
      },
      836: function _(e, t) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.onSubKey = void 0;

        t.onSubKey = function (e) {
          return function (t) {
            return function () {
              var r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                  n = arguments.length > 1 ? arguments[1] : void 0;
              var o = n[e];
              if (void 0 === o) return r;
              var i = t(r[o], n);
              return i === r[o] ? r : _objectSpread(_objectSpread({}, r), {}, _defineProperty2({}, o, i));
            };
          };
        };
      },
      602: function _(e, t) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = function createThunkMiddleware(e) {
          return function () {
            return function (t) {
              return function (r) {
                return "function" == typeof r ? r(e) : t(r);
              };
            };
          };
        };
      },
      838: function _(e, t, r) {
        "use strict";

        var n = r(424);
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.createRegistry = function createRegistry() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
          var r = {},
              n = (0, a.createEmitter)(),
              c = new Set();

          function globalListener() {
            n.emit();
          }

          var subscribe = function subscribe(e) {
            return n.subscribe(e);
          };

          function select(e) {
            var n = (0, o.isObject)(e) ? e.name : e;
            c.add(n);
            var i = r[n];
            return i ? i.getSelectors() : t && t.select(n);
          }

          function __experimentalMarkListeningStores(e, t) {
            c.clear();
            var r = e.call(this);
            return t.current = Array.from(c), r;
          }

          function resolveSelect(e) {
            var n = (0, o.isObject)(e) ? e.name : e;
            c.add(n);
            var i = r[n];
            return i ? i.getResolveSelectors() : t && t.resolveSelect(n);
          }

          function dispatch(e) {
            var n = (0, o.isObject)(e) ? e.name : e,
                i = r[n];
            return i ? i.getActions() : t && t.dispatch(n);
          }

          function withPlugins(e) {
            return (0, o.mapValues)(e, function (e, t) {
              return "function" != typeof e ? e : function () {
                return l[t].apply(null, arguments);
              };
            });
          }

          function registerGenericStore(e, t) {
            if ("function" != typeof t.getSelectors) throw new TypeError("config.getSelectors must be a function");
            if ("function" != typeof t.getActions) throw new TypeError("config.getActions must be a function");
            if ("function" != typeof t.subscribe) throw new TypeError("config.subscribe must be a function");
            t.emitter = (0, a.createEmitter)();
            var n = t.subscribe;
            t.subscribe = function (e) {
              var r = t.emitter.subscribe(e),
                  o = n(function () {
                t.emitter.isPaused ? t.emitter.emit() : e();
              });
              return function () {
                o && o(), r();
              };
            }, r[e] = t, t.subscribe(globalListener);
          }

          function register(e) {
            registerGenericStore(e.name, e.instantiate(l));
          }

          function __experimentalSubscribeStore(e, n) {
            return e in r ? r[e].subscribe(n) : t ? t.__experimentalSubscribeStore(e, n) : subscribe(n);
          }

          function batch(e) {
            n.pause(), (0, o.forEach)(r, function (e) {
              return e.emitter.pause();
            }), e(), n.resume(), (0, o.forEach)(r, function (e) {
              return e.emitter.resume();
            });
          }

          var l = {
            batch: batch,
            registerGenericStore: registerGenericStore,
            stores: r,
            namespaces: r,
            subscribe: subscribe,
            select: select,
            resolveSelect: resolveSelect,
            dispatch: dispatch,
            use: use,
            register: register,
            __experimentalMarkListeningStores: __experimentalMarkListeningStores,
            __experimentalSubscribeStore: __experimentalSubscribeStore
          };

          function use(e, t) {
            return l = _objectSpread(_objectSpread({}, l), e(l, t)), l;
          }

          l.registerStore = function (e, t) {
            if (!t.reducer) throw new TypeError("Must specify store reducer");
            var r = (0, i.default)(e, t).instantiate(l);
            return registerGenericStore(e, r), r.store;
          }, registerGenericStore(u.STORE_NAME, (0, s.default)(l)), Object.entries(e).forEach(function (e) {
            var _e9 = _slicedToArray(e, 2),
                t = _e9[0],
                r = _e9[1];

            return l.registerStore(t, r);
          }), t && t.subscribe(globalListener);
          return withPlugins(l);
        };
        var o = r(793),
            i = n(r(721)),
            s = n(r(936)),
            u = r(655),
            a = r(154);
      },
      988: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = void 0;
        var n = r(793),
            o = r(655);

        var _default = function _default(e, t) {
          return function () {
            return function (r) {
              return function (i) {
                var s = e.select(o.STORE_NAME).getCachedResolvers(t);
                return Object.entries(s).forEach(function (r) {
                  var _r5 = _slicedToArray(r, 2),
                      s = _r5[0],
                      u = _r5[1];

                  var a = (0, n.get)(e.stores, [t, "resolvers", s]);
                  a && a.shouldInvalidate && u.forEach(function (r, n) {
                    !1 === r && a.shouldInvalidate.apply(a, [i].concat(_toConsumableArray(n))) && e.dispatch(o.STORE_NAME).invalidateResolution(t, s, n);
                  });
                }), r(i);
              };
            };
          };
        };

        t.default = _default;
      },
      936: function _(e, t) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = void 0;

        var r = function createCoreDataStore(e) {
          var getCoreDataSelector = function getCoreDataSelector(t) {
            return function (r) {
              var _e$select2;

              for (var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++) {
                o[i - 1] = arguments[i];
              }

              return (_e$select2 = e.select(r))[t].apply(_e$select2, o);
            };
          },
              getCoreDataAction = function getCoreDataAction(t) {
            return function (r) {
              var _e$dispatch2;

              for (var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++) {
                o[i - 1] = arguments[i];
              }

              return (_e$dispatch2 = e.dispatch(r))[t].apply(_e$dispatch2, o);
            };
          };

          return {
            getSelectors: function getSelectors() {
              return ["getIsResolving", "hasStartedResolution", "hasFinishedResolution", "isResolving", "getCachedResolvers"].reduce(function (e, t) {
                return _objectSpread(_objectSpread({}, e), {}, _defineProperty2({}, t, getCoreDataSelector(t)));
              }, {});
            },
            getActions: function getActions() {
              return ["startResolution", "finishResolution", "invalidateResolution", "invalidateResolutionForStore", "invalidateResolutionForStoreSelector"].reduce(function (e, t) {
                return _objectSpread(_objectSpread({}, e), {}, _defineProperty2({}, t, getCoreDataAction(t)));
              }, {});
            },
            subscribe: function subscribe() {
              return function () {};
            }
          };
        };

        t.default = r;
      },
      655: function _(e, t) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.STORE_NAME = void 0;
        t.STORE_NAME = "core/data";
      },
      154: function _(e, t) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.createEmitter = function createEmitter() {
          var e = !1,
              t = !1;

          var r = new Set(),
              notifyListeners = function notifyListeners() {
            return Array.from(r).forEach(function (e) {
              return e();
            });
          };

          return {
            get isPaused() {
              return e;
            },

            subscribe: function subscribe(e) {
              return r.add(e), function () {
                return r.delete(e);
              };
            },
            pause: function pause() {
              e = !0;
            },
            resume: function resume() {
              e = !1, t && (t = !1, notifyListeners());
            },
            emit: function emit() {
              e ? t = !0 : notifyListeners();
            }
          };
        };
      },
      820: function _(e) {
        "use strict";

        function _typeof(e) {
          return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
            return typeof e;
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
          }, _typeof(e);
        }

        function _defineProperties(e, t) {
          for (var r = 0; r < t.length; r++) {
            var n = t[r];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
          }
        }

        function getValuePair(e, t) {
          var r = e._map,
              n = e._arrayTreeMap,
              o = e._objectTreeMap;
          if (r.has(t)) return r.get(t);

          for (var i = Object.keys(t).sort(), s = Array.isArray(t) ? n : o, u = 0; u < i.length; u++) {
            var a = i[u];
            if (void 0 === (s = s.get(a))) return;
            var c = t[a];
            if (void 0 === (s = s.get(c))) return;
          }

          var l = s.get("_ekm_value");
          return l ? (r.delete(l[0]), l[0] = t, s.set("_ekm_value", l), r.set(t, l), l) : void 0;
        }

        var t = function () {
          function EquivalentKeyMap(e) {
            if (function _classCallCheck(e, t) {
              if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            }(this, EquivalentKeyMap), this.clear(), e instanceof EquivalentKeyMap) {
              var t = [];
              e.forEach(function (e, r) {
                t.push([r, e]);
              }), e = t;
            }

            if (null != e) for (var r = 0; r < e.length; r++) {
              this.set(e[r][0], e[r][1]);
            }
          }

          return function _createClass(e, t, r) {
            return t && _defineProperties(e.prototype, t), r && _defineProperties(e, r), e;
          }(EquivalentKeyMap, [{
            key: "set",
            value: function set(e, t) {
              if (null === e || "object" !== _typeof(e)) return this._map.set(e, t), this;

              for (var r = Object.keys(e).sort(), n = [e, t], o = Array.isArray(e) ? this._arrayTreeMap : this._objectTreeMap, i = 0; i < r.length; i++) {
                var s = r[i];
                o.has(s) || o.set(s, new EquivalentKeyMap()), o = o.get(s);
                var u = e[s];
                o.has(u) || o.set(u, new EquivalentKeyMap()), o = o.get(u);
              }

              var a = o.get("_ekm_value");
              return a && this._map.delete(a[0]), o.set("_ekm_value", n), this._map.set(e, n), this;
            }
          }, {
            key: "get",
            value: function get(e) {
              if (null === e || "object" !== _typeof(e)) return this._map.get(e);
              var t = getValuePair(this, e);
              return t ? t[1] : void 0;
            }
          }, {
            key: "has",
            value: function has(e) {
              return null === e || "object" !== _typeof(e) ? this._map.has(e) : void 0 !== getValuePair(this, e);
            }
          }, {
            key: "delete",
            value: function _delete(e) {
              return !!this.has(e) && (this.set(e, void 0), !0);
            }
          }, {
            key: "forEach",
            value: function forEach(e) {
              var t = this,
                  r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this;

              this._map.forEach(function (n, o) {
                null !== o && "object" === _typeof(o) && (n = n[1]), e.call(r, n, o, t);
              });
            }
          }, {
            key: "clear",
            value: function clear() {
              this._map = new Map(), this._arrayTreeMap = new Map(), this._objectTreeMap = new Map();
            }
          }, {
            key: "size",
            get: function get() {
              return this._map.size;
            }
          }]), EquivalentKeyMap;
        }();

        e.exports = t;
      },
      626: function _(e) {
        function isPromise(e) {
          return !!e && ("object" == typeof e || "function" == typeof e) && "function" == typeof e.then;
        }

        e.exports = isPromise, e.exports.default = isPromise;
      },
      671: function _(e, t, r) {
        "use strict";

        function _defineProperty(e, t, r) {
          return t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : e[t] = r, e;
        }

        function ownKeys(e, t) {
          var r = Object.keys(e);

          if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), r.push.apply(r, n);
          }

          return r;
        }

        function _objectSpread2(e) {
          for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? ownKeys(Object(r), !0).forEach(function (t) {
              _defineProperty(e, t, r[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys(Object(r)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
            });
          }

          return e;
        }

        function formatProdErrorMessage(e) {
          return "Minified Redux error #" + e + "; visit https://redux.js.org/Errors?code=" + e + " for the full message or use the non-minified dev environment for full errors. ";
        }

        r.r(t), r.d(t, {
          __DO_NOT_USE__ActionTypes: function __DO_NOT_USE__ActionTypes() {
            return i;
          },
          applyMiddleware: function applyMiddleware() {
            return _applyMiddleware;
          },
          bindActionCreators: function bindActionCreators() {
            return _bindActionCreators;
          },
          combineReducers: function combineReducers() {
            return _combineReducers;
          },
          compose: function compose() {
            return _compose;
          },
          createStore: function createStore() {
            return _createStore;
          }
        });

        var n = "function" == typeof Symbol && Symbol.observable || "@@observable",
            o = function randomString() {
          return Math.random().toString(36).substring(7).split("").join(".");
        },
            i = {
          INIT: "@@redux/INIT" + o(),
          REPLACE: "@@redux/REPLACE" + o(),
          PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
            return "@@redux/PROBE_UNKNOWN_ACTION" + o();
          }
        };

        function isPlainObject(e) {
          if ("object" != typeof e || null === e) return !1;

          for (var t = e; null !== Object.getPrototypeOf(t);) {
            t = Object.getPrototypeOf(t);
          }

          return Object.getPrototypeOf(e) === t;
        }

        function _createStore(e, t, r) {
          var o;
          if ("function" == typeof t && "function" == typeof r || "function" == typeof r && "function" == typeof arguments[3]) throw new Error(formatProdErrorMessage(0));

          if ("function" == typeof t && void 0 === r && (r = t, t = void 0), void 0 !== r) {
            if ("function" != typeof r) throw new Error(formatProdErrorMessage(1));
            return r(_createStore)(e, t);
          }

          if ("function" != typeof e) throw new Error(formatProdErrorMessage(2));
          var s = e,
              u = t,
              a = [],
              c = a,
              l = !1;

          function ensureCanMutateNextListeners() {
            c === a && (c = a.slice());
          }

          function getState() {
            if (l) throw new Error(formatProdErrorMessage(3));
            return u;
          }

          function subscribe(e) {
            if ("function" != typeof e) throw new Error(formatProdErrorMessage(4));
            if (l) throw new Error(formatProdErrorMessage(5));
            var t = !0;
            return ensureCanMutateNextListeners(), c.push(e), function unsubscribe() {
              if (t) {
                if (l) throw new Error(formatProdErrorMessage(6));
                t = !1, ensureCanMutateNextListeners();
                var r = c.indexOf(e);
                c.splice(r, 1), a = null;
              }
            };
          }

          function dispatch(e) {
            if (!isPlainObject(e)) throw new Error(formatProdErrorMessage(7));
            if (void 0 === e.type) throw new Error(formatProdErrorMessage(8));
            if (l) throw new Error(formatProdErrorMessage(9));

            try {
              l = !0, u = s(u, e);
            } finally {
              l = !1;
            }

            for (var t = a = c, r = 0; r < t.length; r++) {
              (0, t[r])();
            }

            return e;
          }

          function replaceReducer(e) {
            if ("function" != typeof e) throw new Error(formatProdErrorMessage(10));
            s = e, dispatch({
              type: i.REPLACE
            });
          }

          function observable() {
            var e,
                t = subscribe;
            return (e = {
              subscribe: function subscribe(e) {
                if ("object" != typeof e || null === e) throw new Error(formatProdErrorMessage(11));

                function observeState() {
                  e.next && e.next(getState());
                }

                return observeState(), {
                  unsubscribe: t(observeState)
                };
              }
            })[n] = function () {
              return this;
            }, e;
          }

          return dispatch({
            type: i.INIT
          }), (o = {
            dispatch: dispatch,
            subscribe: subscribe,
            getState: getState,
            replaceReducer: replaceReducer
          })[n] = observable, o;
        }

        function _combineReducers(e) {
          for (var t = Object.keys(e), r = {}, n = 0; n < t.length; n++) {
            var o = t[n];
            0, "function" == typeof e[o] && (r[o] = e[o]);
          }

          var s,
              u = Object.keys(r);

          try {
            !function assertReducerShape(e) {
              Object.keys(e).forEach(function (t) {
                var r = e[t];
                if (void 0 === r(void 0, {
                  type: i.INIT
                })) throw new Error(formatProdErrorMessage(12));
                if (void 0 === r(void 0, {
                  type: i.PROBE_UNKNOWN_ACTION()
                })) throw new Error(formatProdErrorMessage(13));
              });
            }(r);
          } catch (e) {
            s = e;
          }

          return function combination(e, t) {
            if (void 0 === e && (e = {}), s) throw s;

            for (var n = !1, o = {}, i = 0; i < u.length; i++) {
              var a = u[i],
                  c = r[a],
                  l = e[a],
                  f = c(l, t);

              if (void 0 === f) {
                t && t.type;
                throw new Error(formatProdErrorMessage(14));
              }

              o[a] = f, n = n || f !== l;
            }

            return (n = n || u.length !== Object.keys(e).length) ? o : e;
          };
        }

        function bindActionCreator(e, t) {
          return function () {
            return t(e.apply(this, arguments));
          };
        }

        function _bindActionCreators(e, t) {
          if ("function" == typeof e) return bindActionCreator(e, t);
          if ("object" != typeof e || null === e) throw new Error(formatProdErrorMessage(16));
          var r = {};

          for (var n in e) {
            var o = e[n];
            "function" == typeof o && (r[n] = bindActionCreator(o, t));
          }

          return r;
        }

        function _compose() {
          for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) {
            t[r] = arguments[r];
          }

          return 0 === t.length ? function (e) {
            return e;
          } : 1 === t.length ? t[0] : t.reduce(function (e, t) {
            return function () {
              return e(t.apply(void 0, arguments));
            };
          });
        }

        function _applyMiddleware() {
          for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) {
            t[r] = arguments[r];
          }

          return function (e) {
            return function () {
              var r = e.apply(void 0, arguments),
                  n = function dispatch() {
                throw new Error(formatProdErrorMessage(15));
              },
                  o = {
                getState: r.getState,
                dispatch: function dispatch() {
                  return n.apply(void 0, arguments);
                }
              },
                  i = t.map(function (e) {
                return e(o);
              });

              return n = _compose.apply(void 0, i)(r.dispatch), _objectSpread2(_objectSpread2({}, r), {}, {
                dispatch: n
              });
            };
          };
        }
      },
      196: function _(e) {
        e.exports = function combineReducers(e) {
          var t,
              r = Object.keys(e);
          return t = function () {
            var e, t, n;

            for (e = "return {", t = 0; t < r.length; t++) {
              e += (n = JSON.stringify(r[t])) + ":r[" + n + "](s[" + n + "],a),";
            }

            return e += "}", new Function("r,s,a", e);
          }(), function combinedReducer(n, o) {
            var i, s, u;
            if (void 0 === n) return t(e, {}, o);

            for (i = t(e, n, o), s = r.length; s--;) {
              if (n[u = r[s]] !== i[u]) return i;
            }

            return n;
          };
        };
      },
      625: function _(e, t, r) {
        "use strict";

        r.r(t), r.d(t, {
          useCallback: function useCallback() {
            return i;
          },
          useCallbackOne: function useCallbackOne() {
            return _useCallbackOne;
          },
          useMemo: function useMemo() {
            return o;
          },
          useMemoOne: function useMemoOne() {
            return _useMemoOne;
          }
        });

        var n = require("react");

        function _useMemoOne(e, t) {
          var r = (0, n.useState)(function () {
            return {
              inputs: t,
              result: e()
            };
          })[0],
              o = (0, n.useRef)(!0),
              i = (0, n.useRef)(r),
              s = o.current || Boolean(t && i.current.inputs && function areInputsEqual(e, t) {
            if (e.length !== t.length) return !1;

            for (var r = 0; r < e.length; r++) {
              if (e[r] !== t[r]) return !1;
            }

            return !0;
          }(t, i.current.inputs)) ? i.current : {
            inputs: t,
            result: e()
          };
          return (0, n.useEffect)(function () {
            o.current = !1, i.current = s;
          }, [s]), s.result;
        }

        function _useCallbackOne(e, t) {
          return _useMemoOne(function () {
            return e;
          }, t);
        }

        var o = _useMemoOne,
            i = _useCallbackOne;
      },
      200: function _(e) {
        "use strict";

        e.exports = require("@wordpress/compose");
      },
      703: function _(e) {
        "use strict";

        e.exports = require("@wordpress/deprecated");
      },
      753: function _(e) {
        "use strict";

        e.exports = require("@wordpress/element");
      },
      104: function _(e) {
        "use strict";

        e.exports = require("@wordpress/is-shallow-equal");
      },
      800: function _(e) {
        "use strict";

        e.exports = require("@wordpress/priority-queue");
      },
      40: function _(e) {
        "use strict";

        e.exports = require("@wordpress/redux-routine");
      },
      793: function _(e) {
        "use strict";

        e.exports = require("lodash");
      }
    },
        t = {};

    function __webpack_require__(r) {
      var n = t[r];
      if (void 0 !== n) return n.exports;
      var o = t[r] = {
        exports: {}
      };
      return e[r](o, o.exports, __webpack_require__), o.exports;
    }

    return __webpack_require__.d = function (e, t) {
      for (var r in t) {
        __webpack_require__.o(t, r) && !__webpack_require__.o(e, r) && Object.defineProperty(e, r, {
          enumerable: !0,
          get: t[r]
        });
      }
    }, __webpack_require__.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, __webpack_require__.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, __webpack_require__(453);
  }();
});